import React from "react";
import styled from "styled-components";
import {Page,FlexContainer,PrimaryButton,ScrollableContainer} from "../../components/styled"
import OpenedBg from "../../assets/images/background/openedPackBg.png"
import { useLocation,useNavigate } from "react-router-dom";
import CryptidCard from "../../components/shared/cryptidCard";
import {useUserContext} from "../../context/UserContext";

const OpenedPack = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {fetchUser} = useUserContext();
    const { state } = location;
    if (!state) {navigate("/packOpen")};
    const {cards} = state;
    const onDone =async () => {
        await fetchUser();
        navigate("/inventory")
    };
    return (
        <Page backgroundimage={OpenedBg}>
            <ScrollableContainer>
            <FlexContainer style={{height:"100%"}} flexdirection="column" gap="24px">
                <Container>
                    {React.Children.toArray(
                    cards.map((card, index) => (
                        <CardContainer>
                        <CryptidCard key={index} cryptid={card} />
                        </CardContainer>
                    )))}
                </Container>
                <PrimaryButton style={{width:"50%"}} onClick={onDone}>Done</PrimaryButton>
            </FlexContainer>
            </ScrollableContainer>
        </Page>
    );
};
const Container = styled.div`
    gap: 16px;
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`;
const CardContainer = styled.div`
    aspect-ratio:859/1320;
    width: 27%;
    height: auto;

`
export default OpenedPack;